function SmartBar() {
    return null;
}

export default SmartBar;
